import { useMutation, useQueryClient } from '@tanstack/react-query';
import PracticeService from '../../../services/practice-service';

const useDeletePractice = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => PracticeService.deletePractices(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['practices'] });
      queryClient.invalidateQueries({ queryKey: ['practices-infinite'] });
    },
  });
};

export default useDeletePractice;
